import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { pipe, values, isEmpty, filter, length, lt, identity } from 'ramda';

import { Input, SubmitButton, BottomTextLink, BottomText, Form, BottomTextWrapper } from './loginForm.styles';
import messages from './loginForm.messages';
import { Modal } from '../modal';
import { LOGIN_FIELDS as FIELDS } from '../../../modules/auth/auth.constants';
import { ignoreSpace } from '../../utils/input';

export class LoginForm extends PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    values: PropTypes.object,
    errors: PropTypes.object,
    isSubmitting: PropTypes.bool,
    handleSubmit: PropTypes.func,
    onClose: PropTypes.func,
    onRegisterClick: PropTypes.func,
    onResetPasswordClick: PropTypes.func,
  };

  static defaultProps = {
    onClose: identity,
    onRegisterClick: identity,
  };

  get isEmpty() {
    return pipe(
      values,
      filter(isEmpty),
      length,
      lt(0)
    )(this.props.values);
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.handleSubmit(e);
  };

  handleClose = () => this.props.onClose();

  handleRegisterClick = () => this.props.onRegisterClick();

  handleResetPasswordClick = () => this.props.onResetPasswordClick();

  renderEmailField = ({ field, form }) => (
    <Input
      {...field}
      error={form.errors[FIELDS.email]}
      touched={form.touched[field.name]}
      type="email"
      onKeyDown={ignoreSpace}
      placeholder={this.props.intl.formatMessage(messages.emailPlaceholder)}
    />
  );

  renderPasswordField = ({ field, form }) => (
    <Input
      {...field}
      error={form.errors[FIELDS.password]}
      touched={form.touched[field.name]}
      type="password"
      placeholder={this.props.intl.formatMessage(messages.passwordPlaceholder)}
    />
  );

  render() {
    return (
      <Modal onClose={this.handleClose} title={this.props.intl.formatMessage(messages.title)}>
        <Form onSubmit={this.handleSubmit}>
          <Field name={FIELDS.email} render={this.renderEmailField} />
          <Field name={FIELDS.password} render={this.renderPasswordField} />

          <SubmitButton
            type="submit"
            disabled={this.isEmpty || this.props.isSubmitting}
            label={this.props.intl.formatMessage(messages.submitButton)}
          />
        </Form>

        <BottomTextWrapper>
          <BottomText>
            <BottomTextLink withMargin onClick={this.handleResetPasswordClick}>
              <FormattedMessage {...messages.newPassword} />
            </BottomTextLink>
          </BottomText>
          <BottomText>
            <FormattedMessage {...messages.newToWinnow} />
            <BottomTextLink onClick={this.handleRegisterClick}>
              <FormattedMessage {...messages.createAccount} />
            </BottomTextLink>
          </BottomText>
        </BottomTextWrapper>
      </Modal>
    );
  }
}
